const normalizeFieldKey = (key: string) => {
  const normalizedKey = key.toLowerCase();

  if (normalizedKey.includes("available_until")) {
    return "end_date";
  }

  if (normalizedKey.includes("available_from")) {
    return "start_date";
  }

  if (normalizedKey.startsWith("requirements")) {
    return "conditions";
  }

  if (normalizedKey.startsWith("rewards")) {
    return "rewards";
  }

  return key;
};

export const missionErrorsTransformer = () => {
  return (errors: Record<string, string[]>) => {
    return Object.entries(errors).map(([key, value]) => {
      const targetKey = normalizeFieldKey(key);
      const message = Array.isArray(value) ? value.join(", ") : String(value);

      return {
        [targetKey]: message,
      };
    });
  };
};
